import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppointmentWizardDateStore } from './appointment-wizard-date.store';
import {
    AppointmentWizardDate,
    appointmentWizardDateFactory,
} from './appointment-wizard-date.model';
import { Observable } from 'rxjs';
import { LanguageService } from '../../../core/services/language/language.service';
import { SettingsQuery } from '../settings/settings.query';
import { CompanyQuery } from '../company/company.query';
import { ClinicDetailQuery } from '../clinic-detail/clinic-detail.query';
import { ServiceWizardQuery } from '../service-wizard/service-wizard.query';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentWizardDateQuery } from './appointment-wizard-date.query.';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class AppointmentWizardDateService {
    constructor(
        private appointmentWizardDateStore: AppointmentWizardDateStore,
        private http: HttpClient,
        private languageService: LanguageService,
        private settingsQuery: SettingsQuery,
        private companyQuery: CompanyQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private serviceWizardQuery: ServiceWizardQuery,
        private appointmentWizardDateQuery: AppointmentWizardDateQuery,
        private apiService: ApiService
    ) {}

    /*---------------------*/
    /** OPERACIONES ENTITY */
    /*---------------------*/

    add(appointmentWizardDate: AppointmentWizardDate) {
        this.appointmentWizardDateStore.add(appointmentWizardDate);
    }

    update(id, appointmentWizardDate: Partial<AppointmentWizardDate>) {
        this.appointmentWizardDateStore.update(id, appointmentWizardDate);
    }

    remove(id: ID) {
        this.appointmentWizardDateStore.remove(id);
    }

    setAppointmentWizardDates(dates: AppointmentWizardDate[]) {
        this.appointmentWizardDateStore.set(dates);
    }

    /*---------------*/
    /** LLAMADAS API */
    /*---------------*/

    /**
     * Llamada api para obtener los días disponibles de un mes para una clínica
     */
    private getDatesApi(
        systemKey: string,
        clinicId: string,
        services: string,
        date: string
    ): Observable<any> {
        let params = new HttpParams();
        params = params.append('SystemKey', systemKey);
        params = params.append('ClinicID', clinicId);
        params = params.append('Services', services);
        params = params.append('DiaryDate', date);
        params = params.append('Cmd', 'c1042a');
        params = params.append('Locale', this.languageService.getLocale());

        return this.apiService.callApi(params);
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    /**
     * Llama a la API para obtener las fechas del mes
     */
    async getDatesDisabled(date: NgbDateStruct, currentClinicId: string) {
        /** Los servicios seleccionados los cogemos de Akita */
        const servicesChekedArrayId = [];
        const servicesCheked = this.serviceWizardQuery
            .getAll({
                filterBy: ({ checked }) => checked === true,
            })
            .forEach((service) => {
                servicesChekedArrayId.push(service.id);
            });
        const dates = await this.getDatesApi(
            this.settingsQuery.systemKeyURL,
            currentClinicId,
            servicesChekedArrayId.join(','),
            `${date.year}-${date.month}-${date.day}`
        ).toPromise();

        /**
         * Cargamos las clínicas a la Store
         */
        this.setAppointmentWizardDatesByApi(dates.MonthlyAvailability);
    }

    /**
     * Crea las citas a partir de una Array y las carga en el Store
     */
    setAppointmentWizardDatesByApi(dates) {
        const appointmentWizardDates = this.appointmentWizardDateQuery.getAll();
        dates.forEach((date) => {
            appointmentWizardDates.push(appointmentWizardDateFactory(date));
        });

        this.setAppointmentWizardDates(appointmentWizardDates);
    }

    resetStore() {
        this.appointmentWizardDateStore.reset();
    }
}
